export const inputTemplateIDs = {
  accessoriesTemplateID: '{5F6A1603-3651-4B9E-8DEC-82F291BB3956}',
  checkboxTemplateID: '{60B28C67-200F-4C95-A1F7-98F6B89BC54A}',
  datepickerTemplateID: '{DA59A62E-93E7-4DF1-B3B6-A640F725C1B1}',
  dropdownTemplateID: '{C0E3A32E-7618-458A-81C7-6AE9EFFF71A0}',
  fieldUploadTemplateID: '{841312C3-B15A-4E16-9D5C-D8194BA6A8E0}',
  multiselectorTemplateID: '{793817C2-9E7B-49DE-927D-72EEF8103473}',
  patientInfoTemplateID: '{B82AD06F-5352-435C-9910-E40324400BFE}',
  textFieldTemplateID: '{E8E3D431-CC0B-4E79-9480-03FC2F1D3EE2}',
  textareaTemplateID: '{3DFA7BE7-FF30-47A6-85A7-9987ED6A9ACE}',
};
